export default {"src":"/stays/_next/static/media/beds.e11f34a2.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};